<template>
  <div id="line2">
  </div>
</template>

<script>
import * as echarts from "echarts";
export default {
  props: {
    dataList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      myChart: null,
    };
  },
  watch: {
    dataList: {
      handler: function () {
        this.$nextTick(function () {
          this.buildData();
        });
      },
      deep: true,
    },
  },

  mounted() {
    this.buildData();
    window.onresize = (value) => {
      //每次改变窗口调用一次resize()
      this.myChart.resize();
    };

  },
  methods: {
    //生成柱状图数据
    buildData() {
      var columLabel = ["村居简介", "党务村务", "网上地摊"];
      var colorList = ["#6FC5FF", "#CEFD65", "#3FC7BE"];
      var columName = [];
      var cjznArr = [];
      var dwgkArr = [];
      // var cjswArr = [];
      var wgxqArr = [];
      var arrData = [];
      this.dataList.map((item) => {
        columName.push(item.town);
        cjznArr.push(item.villageGuideNum);
        dwgkArr.push(item.openPartyAffairsNum);
        // cjswArr.push(item.villageAffairsNum);
        wgxqArr.push(item.onlineStallNum);
      });
      arrData.push(cjznArr);
      arrData.push(dwgkArr);
      // arrData.push(cjswArr);
      arrData.push(wgxqArr);

      var columnValue = new Array();
      for (var i = 0; i < columLabel.length; i++) {
        if (typeof columLabel[i] === "undefined") {
          break;
        }
        columnValue.push({
          name: columLabel[i],
          type: "bar",
          data: arrData[i],
          itemStyle: {
            normal: {
              color: colorList[i],
            },
          },
          barWidth: 20, //柱图宽度
        });
      }

      this.init(columLabel, columName, columnValue);
    },
    // 生成图形
    init(columLabel, columName, columnValue) {
      this.myChart = echarts.init(document.getElementById("line2"));
      var option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          data: columLabel,
          itemGap: 17,
          itemHeight: 12,
          textStyle: {
            color: "#ffffff",
            fontSize: 16,
          },
          x: "240",
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "8%",
          containLabel: true,
        },
        xAxis: [
          {
            min: 0,
            type: "category",
            data: columName,
            boundaryGap: true, // x轴两边是否留白
            axisLabel: {
              textStyle: {
                color: "#fff", //坐标值得具体的颜色
                fontSize: 16,
              },
            },
          },
        ],
        // 横向拖动
        dataZoom: [
          {
            type: "slider",
            show: true,
            startValue: 0,
            endValue: 5,
            height: "12",
            bottom: "3%",
            zoomLock: true,
            textStyle: {
              color: "#ffffff",
            },
          },
        ],
        yAxis: [
          {
            min: 0,
            max: function (val) {
              return val.max * 2;
            },
            name: "单位（个）",
            nameTextStyle: {
              color: "#ffffff",
              padding: [0, 0, 10, 0],
              fontSize: 15,
            },
            type: "value",
            // 坐标线
            axisLine: {
              show: true,
            },
            // 坐标刻度线
            axisTick: {
              show: true,
            },
            splitLine: { show: false }, //去除网格线
            axisLabel: {
              textStyle: {
                color: "#fff", //坐标值得具体的颜色
                fontSize: 15,
              },
            },
          },
        ],
        series: columnValue,
      };

      // 使用刚指定的配置项和数据显示图表。
      this.myChart.setOption(option, true);
    },
  },
};
</script>

<style lang="less" scoped>
#line2 {
  width: 100%;
  height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/rightAside/detail_cjt_echart/post_num.vue